import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const AvatarClassName = `${CLASS_NAME_PREFIX}-avatar`;
export const AvatarImageClassName = `${AvatarClassName}__image`;
export const AvatarSvgClassName = `${AvatarClassName}__svg`;
export const AvatarLetterClassName = `${AvatarClassName}__letter`;
export const AvatarGroupClassName = `${CLASS_NAME_PREFIX}-avatar-group`;
export const AvatarGroupShowMoreClassName = `${CLASS_NAME_PREFIX}__show-more`;
